module.exports = __webpack_public_path__ + "static/media/order_cancel.e057ef89.png";